var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h5Template wentizu"},[_c('div',{staticClass:"indexAndTitle"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.ziduan.content["title"]))])])])}
var staticRenderFns = []

export { render, staticRenderFns }